import React, { useEffect, useRef, useState } from 'react';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import verticalIcon from '../../../../../assets/image/vertical-icon.svg';

export default function AccountListTable({
	columns,
	row,
	sortDataList,
	sortDirection,
	setAccountId,
	onRowClick,
	setIsOpenAccountsModal,
	setIsOpenDeactivateConfirmAccountModal,
}) {
	const [openDropdown, setOpenDropdown] = useState(null);
	const dropdownRef = useRef(null);
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const getStatusText = (status) => {
		switch (status) {
			case 1:
				return 'Active';
			case 0:
				return 'Inactive';
			default:
				return '';
		}
	};
	const getStatusColor = (status) => {
		switch (status) {
			case 1:
				return '#68C230';
			case 0:
				return '#FF0000';
			default:
				return '';
		}
	};

	const dropdownOptions = ['View', 'Edit', 'Deactivate'];

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setOpenDropdown(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div className="table-container">
			<table className="custom-table">
				<thead>
					<tr>
						{columns.map((m, idx) => (
							<th
								className={'cursor-pointer'}
								key={`${idx}`}
								onClick={() => {
									sortDataList({ order_by: m.key });
								}}
							>
								<div className="fs-6 fw-bold d-flex justify-content-start align-items-center gap-4">
									{m.label}
									{sortIconMap[sortDirection[m.key]]}
								</div>
							</th>
						))}
					</tr>
				</thead>

				<tbody style={{ height: 'calc(100vh - 278px)' }}>
					{row.map((rowItem, i) => (
						<tr key={i}>
							{columns.map((m, idx) => {
								if (m.key !== 'action') {
									return (
										<td
											key={`${i}-${idx}`}
											className="fs-6 fw-light"
											style={{
												color: m.key === 'status' ? getStatusColor(rowItem[m.key]) : '#000',
											}}
											onClick={() => onRowClick(rowItem.id)}
										>
											{m.key === 'status' ? getStatusText(rowItem[m.key]) : rowItem[m.key]}
										</td>
									);
								}

								return (
									<td key={`${i}-${idx}`}>
										<div
											className="d-flex align-items-center justify-content-center p-2"
											style={{
												position: 'relative',
											}}
										>
											<img
												src={verticalIcon}
												alt="icon"
												width="20px"
												height="20px"
												className="rounded-circle cursor-pointer z-1"
												onClick={(e) => {
													e.preventDefault();
													e.stopPropagation();
													setOpenDropdown(openDropdown === rowItem.id ? null : rowItem.id);
												}}
											/>
										</div>

										{openDropdown === rowItem.id && (
											<div
												className="role-other-permission-dropdown-container bg-white"
												style={{
													position: 'absolute',
													// top: '100%',
													zIndex: 20,
												}}
												onClick={(e) => {
													e.preventDefault();
													e.stopPropagation();
												}}
											>
												{dropdownOptions.map((option, index) => (
													<div
														key={index}
														className="p-2 cursor-pointer fs-6 fw-light"
														onClick={(e) => {
															e.preventDefault();
															e.stopPropagation();

															if (option === 'View') {
																onRowClick(rowItem.id);
															} else if (option === 'Edit') {
																setAccountId(rowItem.id);
																setIsOpenAccountsModal(true);
															} else if (option === 'Deactivate') {
																setAccountId(rowItem.id);
																setIsOpenDeactivateConfirmAccountModal(true);
															}
															setOpenDropdown(null);
														}}
													>
														{option}
													</div>
												))}
											</div>
										)}
									</td>
								);
							})}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
